import React from 'react';

const Urgence = (props) => {
        return (
            <section className="urgence">
                <h2 className="text-uppercase"><i className="fa fa-lg fa-cab"></i> Urgences</h2>
                <div>{props.urgenceData.text} <a href={props.urgenceData.link}>{props.urgenceData.linkText}</a></div>
            </section>
        );
};
export default Urgence;


// WEBPACK FOOTER //
// ./src/components/Urgence.js